import LOGO from'../../assets/logo/honda.png'
export const ICONS = {
    LOGO  
}